var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetaWallBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.91,
    height: 17.49,
    viewBox: "0 0 122.91 17.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "r1PUXe.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66,10c1.61,0,3.2,0,4.79,0,.21,0,.53.48.58.77.47,2.88.89,5.78,1.32,8.66.06.35.17.69.25,1h.25c.08-.32.18-.64.24-1,.42-1.93.84-3.86,1.2-5.79a.83.83,0,0,1,.82-.86.68.68,0,0,1,.2,0c1.26,0,2.56.06,3.83,0,.79,0,1.13.23,1.26,1,.34,1.84.76,3.67,1.16,5.5.07.36.18.71.27,1.06h.26c.08-.32.16-.63.21-.94.42-2.9.89-5.78,1.29-8.68.09-.67.32-.93,1-.91,1.46.05,2.92,0,4.52,0-.07.42-.1.74-.17,1C88.12,16,87,21,85.85,26c-.17.78-.46,1.11-1.31,1.06a33.33,33.33,0,0,0-3.74,0c-.74,0-1-.26-1.14-.92-.5-2.33-1.06-4.65-1.6-7a2,2,0,0,0-.51-1c-.12.29-.22.6-.31.9-.56,2.39-1.13,4.77-1.65,7.15-.13.6-.37.84-1,.84-1.41,0-2.82,0-4.21,0a1.06,1.06,0,0,1-.78-.56c-1.26-5.39-2.47-10.78-3.68-16.18A1.35,1.35,0,0,1,66,10Z",
    transform: "translate(-2.64 -9.83)",
    style: {
      fill: "#000400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.23,18.4l1.12-2.2c.92-1.81,1.86-3.61,2.75-5.46A1.18,1.18,0,0,1,17.36,10c1.12,0,2.24,0,3.37,0,.6,0,.87.18.86.81,0,5.18,0,10.36,0,15.55,0,.26-.28.74-.45.74-1.45.06-2.91,0-4.52,0V18.32l-.29-.09c-.18.27-.38.53-.53.81-.74,1.37-1.5,2.73-2.18,4.13a1.28,1.28,0,0,1-1.38.74,1.34,1.34,0,0,1-1.46-.76c-.7-1.37-1.45-2.7-2.18-4-.16-.3-.35-.58-.52-.84l-.25,0a7.47,7.47,0,0,0-.09.94c0,2.32,0,4.63,0,7,0,.68-.17,1-.91.94-1.12-.06-2.24,0-3.37,0-.58,0-.79-.2-.79-.77V10.74c0-.51.19-.75.73-.74,1.26,0,2.5-.05,3.74,0a1.58,1.58,0,0,1,1,.75c1.15,2.12,2.24,4.28,3.36,6.42C11.68,17.51,11.89,17.83,12.23,18.4Z",
    transform: "translate(-2.64 -9.83)",
    style: {
      fill: "#000400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.13,17c0-.6,0-1.1,0-1.59s.15-.89.8-.87c1.18,0,2.37,0,3.55,0,.48,0,.78.11.78.68,0,3.85,0,7.69,0,11.54a1.39,1.39,0,0,1-.1.33H100.2c0-.61-.09-1.22-.14-2-.23.16-.38.21-.46.32-1.62,2.39-4.55,2.21-6.41,1.23a6.57,6.57,0,0,1-3.3-7,6.09,6.09,0,0,1,5.29-5,4.21,4.21,0,0,1,4.24,1.83c.1.15.22.3.34.45S99.87,16.87,100.13,17ZM94.9,20.9a2.59,2.59,0,0,0,2.59,2.59h0a2.59,2.59,0,1,0,.21-5.17h-.21a2.57,2.57,0,0,0-2.62,2.52v.07Z",
    transform: "translate(-2.64 -9.83)",
    style: {
      fill: "#000400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.21,17V15.35c0-.6.19-.88.84-.86,1.16,0,2.3,0,3.46,0,.56,0,.79.21.79.78,0,3.69,0,7.38,0,11.07,0,.26-.35.72-.56.73-1.42.06-2.86,0-4.38,0-.06-.68-.12-1.29-.18-2a2.59,2.59,0,0,0-.51.42,4.51,4.51,0,0,1-5,1.64,6.37,6.37,0,0,1-4.71-6.68,6.16,6.16,0,0,1,5.3-5.89,4.2,4.2,0,0,1,4.32,1.86q.16.21.36.42C58.88,16.89,59,16.89,59.21,17Zm0,3.92a2.64,2.64,0,1,0-2.67,2.6h.05a2.62,2.62,0,0,0,2.61-2.61Z",
    transform: "translate(-2.64 -9.83)",
    style: {
      fill: "#000400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.14,22.17c.44,1.88,2,2.13,6.37,1.06.17.91.37,1.82.49,2.74,0,.16-.24.45-.42.52a10.57,10.57,0,0,1-7.57.23A6.11,6.11,0,0,1,24.09,20a6.29,6.29,0,0,1,5.41-5.4c4.13-.66,7.07,1.68,7.14,5.62,0,.67-.18,1-.88,1-1.91.19-3.79.47-5.7.72C29.74,22,29.44,22.11,29.14,22.17ZM31,17.25a2.26,2.26,0,0,0-2.1,2.1c0,.17.42.49.62.47a22.59,22.59,0,0,0,2.42-.5c.31-.08.84-.3.84-.42a1.46,1.46,0,0,0-.48-1A6.69,6.69,0,0,0,31,17.25Z",
    transform: "translate(-2.64 -9.83)",
    style: {
      fill: "#000400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.37,23.33c.06,1,.16,1.85.14,2.72a1,1,0,0,1-.56.71,14.57,14.57,0,0,1-3.56.47,3.87,3.87,0,0,1-3.77-3.86c-.11-1.39,0-2.79-.06-4.2s0-1.49-1.61-1.68c0-.81,0-1.66,0-2.49,0-.14.48-.39.71-.37a1.57,1.57,0,0,0,1.81-1.15c.42-1,1-1.93,1.41-2.92s1.42-.65,2.17-.61.47.76.5,1.21c0,.89,0,1.78,0,2.67,0,.56.23.84.8.78h.19c2.07,0,2.34.37,2,2.44,0,.2-.32.36-.51.51s-.19,0-.29,0c-2.15.08-2.15.08-2.15,2.21v1.81c.07,1.35.59,1.81,1.93,1.77Z",
    transform: "translate(-2.64 -9.83)",
    style: {
      fill: "#000400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.65,9.92V21.27c0,1.9.37,2.23,2.28,2.06h.5c0,.93.14,1.84.11,2.74a.84.84,0,0,1-.54.64,15.81,15.81,0,0,1-3.84.5c-2.14-.16-3.51-1.75-3.58-4.14-.11-3.93,0-7.87,0-11.81,0-.21.23-.58.4-.61C119.45,10.37,121,10.17,122.65,9.92Z",
    transform: "translate(-2.64 -9.83)",
    style: {
      fill: "#000400"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.11,9.92V21.59c0,1.43.43,1.89,1.82,1.76.79-.07,1,.18,1,.91.13,2.48.1,2.55-2.37,2.94-3.4.53-5.5-1.07-5.6-4.51-.12-3.79,0-7.57,0-11.35,0-.24.17-.65.32-.68C109.83,10.4,111.4,10.18,113.11,9.92Z",
    transform: "translate(-2.64 -9.83)",
    style: {
      fill: "#000400"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaWallBlack);
export default __webpack_public_path__ + "static/media/MetaWall_black.4e44ec35180eaa003c28d30a432fdb82.svg";
export { ForwardRef as ReactComponent };